import { Button } from "@mui/material";
import {
  CenterModalHeader,
  MuiBox,
  MuiTypography,
  SubmitLoaderButton,
} from "components/atoms";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { UpdateProfileAction } from "store/middlewares/profile";
import { closeCenterModal } from "store/slices/CenterModal.slice";

const ChangeName = ({ type = "firstName", value, oldValue }) => {
  const dispatch = useDispatch();
  const [loader, setLoader] = React.useState(false);
  const { t } = useTranslation();

  return (
    <MuiBox sx={{ overflow: "auto", p: "0px" }}>
      <MuiBox sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <CenterModalHeader
          title={
            type === "firstName"
              ? t("modal.editProfile.changeFirstName")
              : t("modal.editProfile.changeLastName")
          } /*  */
        />
        <MuiBox
          sx={{
            bgcolor: "background.white",
            borderRadius: "0px 0px 12px 12px",
            overflow: "hidden",
          }}
        >
          <MuiBox sx={{ p: "20px" }}>
            <MuiTypography
              variant="14"
              fontWeight={"400"}
              sx={{ color: "text.neutral", wordBreak: "break-word" }}
            >
              {t(
                type === "firstName"
                  ? "modal.editProfile.AreYouSureYouChangeFirstName"
                  : "modal.editProfile.AreYouSureYouChangeLastName",
                {
                  oldValue,
                  newValue: value?.[type],
                },
              )}
            </MuiTypography>
          </MuiBox>
          <MuiBox
            sx={{
              display: "flex",
              gap: "12px",
              bgcolor: "background.gray200",
              p: "16px 20px",
              justifyContent: "end",
              flexWrap: { xs: "wrap-reverse", sm: "nowrap" },
            }}
          >
            <Button
              variant="whiteContained"
              sx={{
                width: "fit-content",
                border: "2px solid",
                borderColor: "background.blue600",
              }}
              onClick={() => dispatch(closeCenterModal())}
            >
              <MuiTypography
                variant="14"
                component={"span"}
                textAlign={"center"}
                fontWeight={"500"}
                color="primary.main"
              >
                {t("commonButton.cancel")}
              </MuiTypography>
            </Button>
            <SubmitLoaderButton
              onClick={() => {
                setLoader(true);
                dispatch(
                  UpdateProfileAction({
                    ...value,
                    onSuccess: () => {
                      setLoader(false);
                    },
                    onError: () => {
                      setLoader(false);
                    },
                  }),
                );
              }}
              variant="blueContained"
              btnText={t("setting.update")}
              isDisable={loader}
              isLoading={loader}
              type="submit"
            />
          </MuiBox>
        </MuiBox>
      </MuiBox>
    </MuiBox>
  );
};

export default ChangeName;
